// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2007) return "static/chunks/2007.ed8fed46e949d652.js";
	if (chunkId === 3987) return "static/chunks/a3319169.05fae8d158e45e56.js";
	if (chunkId === 1056) return "static/chunks/1056.b94eaff86b953fe7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1426":"f61d85b89b52f638","1900":"59901632d723ff0f","2170":"571ffc8b2c8c3fd0","2260":"e72e16f15c270784","3904":"6c31651c65979fce","9384":"410747e56ee5cee7"}[chunkId] + ".js";
};